module.exports = __webpack_public_path__ + "static/media/courtesy.34e30146.svg";